import React, { Component } from "react";
import _ from "lodash";
import { Col } from "reactstrap";
import { connect } from "react-redux";
import { redirectOperator } from "routes/RedirectRoutes";
import { handleError } from "appRedux/actions/Common";
import { BackButtonLink } from "components";
import ExpandableForm from "./ExpandableForm";
import { getRouteFromOperator } from "../actions";
import Loader from "components/Loader";
import { useTheme } from "context/themeContext";

class OperatorToken extends Component {
  state = {
    amount: "",
  };

  handleCompletion = () => {
    this.props.isCompleted();
  };

  componentDidMount() {
    const selectedOp = JSON.parse(sessionStorage.getItem("selectedOperators"));
    if (_.isEmpty(selectedOp)) {
      handleError("No operator selected");
      redirectOperator();
    }
  }

  render() {
    
    const { loading, color, selectedOperatorListData,countryProperties} = this.props;

    const operatorsFormCards = selectedOperatorListData.map((operator) => (
      <ExpandableForm
        key={operator.id}
        operatorTitle={operator.name}
        operatorId={operator.id}
        operator={operator}
        handleCompletion={this.handleCompletion} // Passing the function as a prop
        color={color}
        countryProperties={countryProperties}
       
      />
    ));

    return (
      <>
        {loading ? (
          <Loader />
        ) : (
          <Col sm="12" md={{ size: 10, offset: 0 }}>
            <div className="login-form x-form">
              <div className="pad_holder">
                {selectedOperatorListData.length !== 0 && (
                  <>
                    {operatorsFormCards}
                    <BackButtonLink />
                  </>
                )}
              </div>
            </div>
          </Col>
        )}
      </>
    );
  }
}

const mapStateToProps = ({ buyOperatorState, selectOperatorState }) => {
  const { loading } = selectOperatorState;

  const selectedOperatorListData = selectOperatorState.selectedOperators;
  const operators = selectOperatorState.operators;
  const operatorTokensToBePurchased = buyOperatorState.operatorTokens;

  return {
    // walletBalance,
    operatorTokensToBePurchased,
    operators,
    selectedOperatorListData,
    loading,
  };
};

export default connect(mapStateToProps, {
  handleError,
  getRouteFromOperator,
})(OperatorToken);
